import React from 'react';
import { Divider, HStack, Text, VStack } from '@adc/parallax-component-library';
import { IconBack } from '@adc/parallax-icons';
import { usePartner } from 'Hooks';
import { IconButton } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ActionBarHeader = ({ testID }) => {
    const { partner } = usePartner();
    if (!partner) {
        return null;
    }
    return (React.createElement(VStack, null,
        React.createElement(HStack, { alignItems: "center", padding: "$2" },
            React.createElement(IconButton, { testID: `${testID}.action-back-btn`, marginRight: "$2", onPress: () => window.location.replace(partner.website) },
                React.createElement(IconBack, { testID: `${testID}.action-back-btn-icon`, size: "XS", color: "$interactive.tertiary.enabled.onColor" })),
            React.createElement(Text, { testID: `${testID}.action-back-btn-text`, fontSize: "$bodySmall.default", color: "$interactive.tertiary.enabled.onColor" }, i18n.t('Login.content.returnPartnerHeader.bodyText', {
                partnerName: partner.displayName,
            }))),
        React.createElement(Divider, { marginTop: "$2", borderColor: "$neutral.40" })));
};
export { ActionBarHeader };
